//hook
import { useState, useEffect } from 'react';
import { UserConsumer } from '../hooks/context/UserContext';
import { NotificationConsumer } from '../hooks/context/NotificationContext';


//component
import AuthDialog from '../Auth/AuthDialog';
import Otp from '../Auth/Otp';

//api
import { ApiGetLogout } from '../api/ApiGetLogout';

//mui
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';

//material ui icons
import LanguageIcon from '@mui/icons-material/Language';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

//image
import gettak_logo from "../assets/header/gettak-logo.png"

//react router dom
import { Link } from 'react-router-dom';

const pages = ['home', 'about', 'contact', 'privacy_policy'];
const settings = ['profile', 'logout'];


const Header = () => {
  const token = localStorage.getItem("token")
  const { t } = useTranslation();
  let {userData, setUserData, theme, setTheme} = UserConsumer()
  let {setNoteMessage, setShowMessage, setStatusCode} = NotificationConsumer()
  const [openOtp, setOpenOtp] = useState(false);
  
  // start the translation way
  
  // change the lang on click
  const handleClick = () => {
    const newLang = i18n.language === "ar" ? "en" : "ar";
    i18n.changeLanguage(newLang);
  };
  // set default language only once
  useEffect(() => {
  const savedLang = localStorage.getItem("i18nextLng");
  const alreadyReloaded = localStorage.getItem("reloaded");
  const lang = savedLang ? savedLang.startsWith("en") ? "ar" : savedLang : "en";
  if(!alreadyReloaded) {
    localStorage.setItem("reloaded", "true");
    i18n.changeLanguage(lang);
    window.location.reload();
  }
  }, []);

  // end the translation way

  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = async ()=>{
    try {
      const result = await ApiGetLogout();
      if(result.code == 200) {
        localStorage.removeItem("token")
        console.log('logout successful:');
        setUserData(null)
        setNoteMessage(result.message)
        setShowMessage(true)
        setStatusCode(result.code)
        setTheme("client")
      }
      handleCloseUserMenu()
    }
    catch(error) {
      console.error('logout failed', error);
    }
  }
  return (
    <div>
      <AppBar position="fixed" className='!bg-white'>
        <Container maxWidth="xl">
          <Toolbar className="justify-between" disableGutters>
            {/* more than 900px */}
            <Box sx={{ display: { xs: 'none', md: 'flex' }, flexWrap: "wrap" }} className='flex items-center gap-2'>
              <img className='w-[100px] h-[75px]' src={gettak_logo} alt='no=photo'/>
            </Box>
            <Box sx={{ flexGrow: 0, gap: "10px", display: { xs: 'none', md: 'flex' }}}>
              {pages.map((page) => (
                <Link key={page} to={page === "home" ? "client" : `client/${page}`}>
                  <Button
                    sx={{ my: 2, color: 'black', display: 'block' }}
                  >
                    {t(page)}
                  </Button>
                </Link>
              ))}
            </Box>
            
            {/* less than 900px */}
            <Box sx={{display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                className='!text-customerColor'
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{ display: { xs: 'block', md: 'none' } }}
              >
                {pages.map((page) => (
                  <MenuItem key={page} onClick={handleCloseNavMenu}>
                    <Link to={page === "home" ? "client" : `client/${page}`}>
                      <Typography sx={{ textAlign: 'center' }}>{t(page)}</Typography>
                    </Link>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="#app-bar-with-responsive-menu"
              sx={{
                display: { xs: 'flex', md: 'none' },
              }}
            >
              <Box sx={{ display: { xs: 'flex', md: 'none', flexWrap: "wrap", width: "100%" }}}>
                <img className='w-[100px] h-[75px]' src={gettak_logo} alt='no=photo'/>
              </Box>
            </Typography>

            
            <Box sx={{ display: "flex", flexWrap: "wrap"}}>
              <div>
                {token 
                ? 
                <>
                  <Tooltip title="Open settings">
                    <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                      <Avatar alt={userData?.full_name} className="!bg-customerColor" src="/static/images/avatar/2.jpg" />
                    </IconButton>
                  </Tooltip>
                  <Menu
                    sx={{ mt: '45px' }}
                    id="menu-appbar"
                    anchorEl={anchorElUser}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    open={Boolean(anchorElUser)}
                    onClose={handleCloseUserMenu}
                  >
                    {settings.map((setting) => (
                      <MenuItem key={setting} onClick={setting === "logout" ? handleLogout : handleCloseUserMenu}>
                        <Link to={setting === "logout" ? "client" : `client/${setting}`}>
                          <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
                        </Link>
                      </MenuItem>
                    ))}
                  </Menu>
                </>
                :
                <div className='flex'>
                    <AuthDialog setOpenOtp = {setOpenOtp}/>
                </div>
                }
              </div>
              <Otp 
                openOtp = {openOtp} 
                setOpenOtp = {setOpenOtp}
              />
              <Button
                onClick={handleClick}
                className='!text-black'
                style={{fontWeight: "bold"}}
              >
                <LanguageIcon fontSize="small" />
                <span>{i18n.language === "ar" ? t("En") : t("Ar")}</span>
              </Button>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  )
}

export default Header